import { useAttachmentFieldCommit as useSharedFieldCommit } from '@features/Attachments/hooks/useAttachmentFieldCommit';
import { translate } from '@utils/i18n';
import { BUILDING_ATTACHMENTS_ENTITY_KEY, EDIT_MODAL_ERRORS_NS } from '../constants';
import { updateBuildingAttachment } from '../services/buildingAttachmentsApi';
/**
 * Building's binding of the shared single-field commit: pins the entity key and the PATCH endpoint
 * so the inline cells stay free of both.
 */
export function useAttachmentFieldCommit(buildingId, attachmentId) {
    return useSharedFieldCommit({
        entityKey: BUILDING_ATTACHMENTS_ENTITY_KEY,
        ownerId: buildingId,
        attachmentId,
        update: updateBuildingAttachment,
        genericErrorMessage: translate('generic', { namespace: EDIT_MODAL_ERRORS_NS })
    });
}
